import InputRoot from './Root';
import InputContainer from './Container';
import InputLabel from './Label';
import InputError from './Error';
import InputSpecificError from './SpecificError';

const Input = {
  Root: InputRoot,
  Label: InputLabel,
  Container: InputContainer,
  Error: InputError,
  SpecificError: InputSpecificError,
};

export default Input;
